import { CheckCircle2, HelpCircle, AlertCircle } from "lucide-react-native";
import { useTranslations } from "@src/packages/i18n";
import StatusBadge from "../../components/StatusBadge";

export type EligibilityStatus =
  "eligible" | "potentially_eligible" | "info_needed";

const CONFIG: Record<
  EligibilityStatus,
  {
    labelKey: string;
    tone: "green" | "gold" | "neutral";
    Icon: typeof CheckCircle2;
  }
> = {
  eligible: {
    labelKey: "costs.grant_eligibility.eligible",
    tone: "green",
    Icon: CheckCircle2,
  },
  potentially_eligible: {
    labelKey: "costs.grant_eligibility.potentially_eligible",
    tone: "gold",
    Icon: HelpCircle,
  },
  info_needed: {
    labelKey: "costs.grant_eligibility.more_info_needed",
    tone: "neutral",
    Icon: AlertCircle,
  },
};

export default function EligibilityBadge({
  status,
}: {
  status: EligibilityStatus;
}) {
  const t = useTranslations();
  const config = CONFIG[status];

  return (
    <StatusBadge
      label={t(config.labelKey)}
      tone={config.tone}
      icon={config.Icon}
    />
  );
}
